// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"6":"875a596b","85":"38fed45e","272":"2d415c55","649":"1935854f","749":"aaa9e9dc","832":"93f477aa"}[chunkId] + ".css";
};